// import utils from '../common/util';
// import * as cmpDataContainer from './cmp-data-container';

const cmpModal = {
	component: null,

	/**
	 * Initialise the component
	 * @param element
	 */
	init: function (element)
	{
		const _ = this;

		_.element = element;
		_.header = element.querySelector('.modal__header').querySelector('h5');
		_.footer = element.querySelector('.modal__footer');
		_.closeBtn = element.querySelector('[data-modal-close]');
		_.deleteBtn = element.querySelector('[data-modal-delete]');
		_.submitBtn = element.querySelector('[data-modal-submit]');
		_.triggers = document.querySelectorAll('[data-modal-trigger]');
		_.deleteForm = element.querySelector('.delete-form');
		_.updateCreateForm = element.querySelector('.update-create-form');

		_.onTriggerClickEvent();
		_.onCloseEvent();
	},

	/**
	 * Set on click events for each button
	 */
	onTriggerClickEvent: function ()
	{
		const _ = this;

		for (let trigger of _.triggers) {
			trigger.addEventListener('click', (e) =>
			{
				let clicked = e.target;
				let attributes = _.getClickedItemAttributes(clicked);

				console.log(attributes);

				_.setModalTitle(attributes);
				_.setModalSubmitButtonLabel(attributes);
				_.showHideDeleteButton(attributes);
				_.setFieldValues(attributes);
				_.element.classList.add('active');
			})
		}
	},

	onCloseEvent()
	{
		const _ = this;

		if (_.closeBtn) {
			_.closeBtn.addEventListener('click', () =>
			{
				_.element.classList.remove('active');
			})
		}
	},

	getClickedItemAttributes: function (trigger)
	{
		return trigger.dataset;
	},

	setModalTitle(attributes)
	{
		const _ = this;

		if (attributes['modalTitle']) {
			_.header.textContent = attributes['modalTitle'];
		}
	},

	setModalSubmitButtonLabel(attributes)
	{
		const _ = this;

		if (attributes['modalSubmitLabel']) {
			_.submitBtn.value = attributes['modalSubmitLabel'];
		}
	},

	showHideDeleteButton(attributes)
	{
		const _ = this;

		_.deleteBtn.style.display = (attributes['modalDeleteBtn'] || 'false') === 'true' ? 'block' : 'none'
	},

	setFieldValues(attributes)
	{
		const _ = this;

		if (attributes['modalDate']) {
			_.element.querySelector('.modal-date').value = attributes['modalDate'];
		}

		if (attributes['modalOvertimeType']) {
			_.element.querySelector('.modal_overtime_type').value = attributes['modalOvertimeType'];
		}

		if (attributes['modalUserId']) {
			_.element.querySelector('.modal-team-member').value = attributes['modalUserId'];
		}

		if (attributes['modalDisableUser']) {
			_.element.querySelector('.modal-team-member').classList.add('readonly');
			_.element.querySelector('.modal-team-member').setAttribute('tabindex', -1);
			_.element.querySelector('.modal-team-member').setAttribute('aria-disabled', true);

		} else {
			_.element.querySelector('.modal-team-member').classList.remove('readonly');
			_.element.querySelector('.modal-team-member').removeAttribute('tabindex');
			_.element.querySelector('.modal-team-member').removeAttribute('aria-disabled');
		}

		if (attributes['modalDeleteUrl']) {
			_.deleteForm.setAttribute('action', attributes['modalDeleteUrl']);
			_.deleteForm.querySelector('input[name="overtime_date"]').value = attributes['modalDate'] || '';
			_.deleteForm.querySelector('input[name="overtime_type_id"]').value = attributes['modalOvertimeType'] || '';
			_.deleteForm.querySelector('input[name="user_id"]').value = attributes['modalUserId'] || '';
			_.deleteBtn.addEventListener('click', (e) =>
			{
				e.preventDefault();
				if (confirm('Are you sure you want to delete this overtime')) {
					_.deleteForm.submit();
				}
			});
		}

		if (attributes['modalUpdateUrl']) {
			_.updateCreateForm.setAttribute('action', attributes['modalUpdateUrl']);
			_.updateCreateForm.querySelector('.modal-method').value = 'PATCH';
			_.updateCreateForm.querySelector('.modal-old-date').value = attributes['modalDate'] || '';
			_.updateCreateForm.querySelector('.modal-old-overtime-type').value = attributes['modalOvertimeType'] || '';
		}

		if (attributes['modalCreateUrl']) {
			_.updateCreateForm.setAttribute('action', attributes['modalCreateUrl']);
			_.updateCreateForm.querySelector('.modal-method').value = 'POST';
		}
	}
}

export default cmpModal;
